import { roundUpPrice } from '@/utils/circuits/prices/formatPrice';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import i18next from '@/i18n/config';

export type ReceiverDataWithStats = {
  id: string;
  ref: number;
  name: string;
  country: string | null;
  createdAt: string;
  _count: {
    circuits: number;
    distributors: number;
    suppliers: number;
    benefits: number;
  };
  reserved: number;
  inWait: number;
  received: number;
  pending: number;
  transformationRateInWait: number;
  transformationRateReceived: number;
  transformationRatePending: number;
};

const t = i18next.t;

export const ALL_RECEIVERS_COLUMNS: ColumnDef<ReceiverDataWithStats>[] = [
  {
    accessorKey: 'ref',
    header: t('pages.admin.receivers.columns.code'),
  },
  {
    accessorKey: 'name',
    header: t('pages.admin.receivers.columns.name'),
  },
  {
    accessorKey: 'country',
    header: t('pages.admin.receivers.columns.country'),
  },
  {
    accessorKey: 'createdAt',
    header: t('pages.admin.receivers.columns.createdAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
  },
  {
    accessorKey: '_count.circuits',
    header: t('pages.admin.receivers.columns.circuitsCount'),
  },
  {
    accessorKey: '_count.benefits',
    header: t('pages.admin.receivers.columns.benefitsCount'),
  },
  {
    accessorKey: '_count.distributors',
    header: t('pages.admin.receivers.columns.distributorsCount'),
  },
  {
    accessorKey: 'reserved',
    header: t('pages.admin.receivers.columns.reservations'),
  },
  {
    accessorKey: 'inWait',
    header: t('pages.admin.receivers.columns.inWait'),
  },
  {
    accessorKey: 'received',
    header: t('pages.admin.receivers.columns.received'),
  },
  {
    accessorKey: 'pending',
    header: t('pages.admin.receivers.columns.pending'),
  },
  {
    accessorKey: 'transformationRateInWait',
    header: t('pages.admin.receivers.columns.transformationRateInWait'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRateInWait * 100)} %`}</span>
    ),
  },
  {
    accessorKey: 'transformationRateReceived',
    header: t('pages.admin.receivers.columns.transformationRateReceived'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRateReceived * 100)} %`}</span>
    ),
  },
  {
    accessorKey: 'transformationRatePending',
    header: t('pages.admin.receivers.columns.transformationRatePending'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRatePending * 100)} %`}</span>
    ),
  },
];
